import { gql } from '@apollo/client';

export const UPSERT_PORTFOLIO = gql`
  mutation UpsertPortfolio($input: UpsertPortfolioInput!) {
    portfolio: upsertPortfolio(input: $input) {
      id
    }
  }
`;
